import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BuilderSharedModule } from '@gh/builder-shared';
import { LeadListComponent } from './components/lead-list/lead-list.component';
import { BulkEditLeadsDialogComponent } from './components/bulk-edit-leads-dialog/bulk-edit-leads-dialog.component';
import { BulkReassignLeadsDialogComponent } from './components/bulk-reassign-leads-dialog/bulk-reassign-leads-dialog.component';
import { CopyArchiveLeadDialogComponent } from './components/copy-archive-lead-dialog/copy-archive-lead-dialog.component';
import { LeadListBusinessService } from './resources/lead-list-business.service';
import { BuilderLeadsRoutingModule } from './builder-leads-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderLeadsRoutingModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
  ],
  providers: [
    LeadListBusinessService,
  ],
  declarations: [
    LeadListComponent,
    BulkEditLeadsDialogComponent,
    BulkReassignLeadsDialogComponent,
    CopyArchiveLeadDialogComponent,
  ],
})
export class BuilderLeadsModule {
}
